import {Component, ElementRef, Inject, PLATFORM_ID, TemplateRef, ViewChild} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/shared/services/toast.service';

@Component({
  selector: 'app-toasts',
  templateUrl: './toasts.component.html',
  styleUrls: ['./toasts.component.scss']
})
export class ToastsContainer  {

  @ViewChild('content') content: ElementRef;

  message = '';
  classname = '';
  isSuccess = false;
  autoClose = true;
  private readonly isBrowser: boolean;

  constructor(
    public toastService: ToastService, 
    private modalService: NgbModal,
    @Inject(PLATFORM_ID) platformId: object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.toastService.modal.subscribe( (config: any) => {
      if (!this.isBrowser) return;
      const {textOrTpl, success, autoClose} = config;
      this.message = textOrTpl;
      this.isSuccess = success;
      this.autoClose = autoClose === undefined ? true : autoClose;
      const modalRef = this.open(this.autoClose);
      if(this.autoClose && modalRef){
        setTimeout(() => modalRef.close(), 3000);
      }
    });
  }

  open(autoClose: boolean): NgbModalRef {
    return this.modalService.open(this.content, {
      animation: true,
      centered: !autoClose
    });
  }

}
